import { render, staticRenderFns } from "./detalhesVersao.vue?vue&type=template&id=036a7039&scoped=true&"
import script from "./detalhesVersao.vue?vue&type=script&lang=js&"
export * from "./detalhesVersao.vue?vue&type=script&lang=js&"
import style0 from "./detalhesVersao.vue?vue&type=style&index=0&id=036a7039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a7039",
  null
  
)

export default component.exports